/*
 * @Author: 李才人
 * @Date: 2021-07-08 10:00:00
 * @LastEditors: 李才人
 * @LastEditTime: 2021-07-08 10:22:55
 * @FilePath: \m_saas_business_admin\src\dataBase\authCodeMap\marketing.ts
 * @Description: 营销模块code码
 */
export const marketing = {
  /**
   * # 积分设置模块
   */
  operationManage_integralSet: "operationManage_integralSet",
  operationManage_integralSet_setting: "operationManage_integralSet_setting",
  operationManage_integralSet_integralRule: "operationManage_integralSet_integralRule",
  operationManage_integralSet_integralRule_status: "operationManage_integralSet_integralRule_status",
  operationManage_integralSet_integralRule_delete: "operationManage_integralSet_integralRule_delete",
  operationManage_integralSet_userIntegral: "operationManage_integralSet_userIntegral",
  marketing_operationManage_productManage_add: "marketing_operationManage_productManage_add",
  marketing_operationManage_productManage: "marketing_operationManage_productManage",
  marketing_operationManage_productManage_detail: "marketing_operationManage_productManage_detail",
  marketing_operationManage_infoManage: "marketing_operationManage_infoManage"
};